<div class="flex flex-auto justify-between">
  <properties-header-menu
    [currentTabId]="currentTabId"
    [propertyRoute]="propertyRoute"
    [editMode]="editMode"
    [property]="property"
    [account]="account"
    [dashboardDef]="propertyTemplate?.definition?.dashboard"
    [userRole]="userRole"
    (onTabOrderChanged)="onTabOrderChanged($event)"
    (onTabAdded)="onTabAdded($event)"
    (onTabRemoved)="onTabRemoved($event)"
    (onTabTitleEdit)="onTabTitleEdit($event)"
  >
  </properties-header-menu>
  <div class="flex flex-row items-center px-4">
    @if (!editMode) {
      <ts-button
        type="stroked"
        color="accent"
        (click)="toggleEditMode($event, undefined)"
        [appAuthorize]="authorizeEditLayout()"
        denyAction="disable"
      >
        <ts-icon [icon]="'edit'"></ts-icon>
        Edit Layout
      </ts-button>
    } @else {
      <ts-button class="pr-2" type="flat" color="warn" (click)="toggleEditMode($event, true)">
        <ts-icon [icon]="'close'"></ts-icon>
        Cancel
      </ts-button>
      <ts-button type="flat" color="success" (click)="toggleEditMode($event, false)">
        <ts-icon [icon]="'save'"></ts-icon>
        Save
      </ts-button>
    }
  </div>
</div>
